// extracted by mini-css-extract-plugin
module.exports = {"section":"QueueMessage_section__VlybO","scroller":"QueueMessage_scroller__CGOS6","scrollInner":"QueueMessage_scrollInner__1Nl_W","scroll":"QueueMessage_scroll__ohPrJ"};